import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import {useEffect, useState} from 'react'
import useAtmosphere from '../hooks/useAtmosphere'
import useRouter from '../hooks/useRouter'
import DialogContent from './DialogContent'
import DialogTitle from './DialogTitle'
import InviteDialog from './InviteDialog'
import StyledError from './StyledError'
import TeamInvitationMeetingAbstract from './TeamInvitationMeetingAbstract'

const SAMLRedirect = () => {
  const [error, setError] = useState('')
  const atmosphere = useAtmosphere()
  const {history} = useRouter()
  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const token = params.get('token')
    const error = params.get('error')
    let isSameOriginPopup = false
    if (window.opener) {
      try {
        // cross-domain attempts to access opener.location.origin will throw
        // this makes sure that Parabol opened the popup
        isSameOriginPopup = !!window.opener.location.origin
      } catch (e) {
        /* noop */
      }
    }
    if (isSameOriginPopup) {
      // SP-initiated
      window.opener.postMessage({token, error}, window.location.origin)
    } else {
      // IdP-initiated
      if (!token) {
        setError(error || 'Error logging in')
      } else {
        atmosphere.setAuthToken(token)
        history.replace('/meetings')
      }
    }
  }, [])

  if (error) {
    const errors = error.split('|')
    return (
      _jsx(TeamInvitationMeetingAbstract, { children: 
        _jsxs(InviteDialog, { children: [
          _jsx(DialogTitle, { children: "SSO Login" })
          , _jsx(DialogContent, { children: 
            errors.map((error, idx) => (
              _jsx(StyledError, { children: error}, idx)
            ))
          })
        ]})
      })
    )
  }
  return null
}

export default SAMLRedirect
